export const MIN_Y = window.innerHeight + 14; // 바텀시트가 최대로 높이 올라갔을 때의 y 값
export const MAX_Y = 360; // 바텀시트가 최소로 내려갔을 때의 y 값
// export const BOTTOM_SHEET_HEIGHT = window.innerHeight - MIN_Y; // 바텀시트의 세로 길이
